const actions = {
  SET_STATE: 'notification/SET_STATE',
  RESET_STATE: 'notification/RESET_STATE',
  SEND_NOTIFICATION: 'notification/SEND_NOTIFICATION',
}

export default actions
